import React from 'react';
import { Icon } from 'zarm';
import './index.less';

const ConfirmTip = props => {
  const {
    text = ''
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: "c-confirmTip-component"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "info-round",
    theme: "warning",
    className: "c-icon-warning"
  }), /*#__PURE__*/React.createElement("span", null, text));
};

export default ConfirmTip;